// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorPage_errorContainer__YQNgv","title":"ErrorPage_title__7um6J","errorDescriptionCard":"ErrorPage_errorDescriptionCard__-tmAY"};